import type { ReactNode } from 'react';

export const symbol_desktop_cloud: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M360-410h260q37.8 0 63.9-26.61t26.1-64.5Q710-539 682.94-565T618-591h-9l-1-9q-7-48-43.26-79-36.27-31-84.62-31Q442-710 411-690q-31 20-48 55l-3 5-6 1q-43.79 1.83-73.89 33.48Q250-563.88 250-519.86 250-474 282.08-442q32.09 32 77.92 32Zm0-60q-21.25 0-35.62-14.32Q310-498.65 310-519.82q0-21.18 14.38-35.68Q338.75-570 360-570h40q0-33.14 23.4-56.57T479.9-650q33.1 0 56.6 23.43T560-570v40h60q13 0 21.5 8.5T650-500q0 13-8.5 21.5T620-470H360Zm60 290v-100H140q-24 0-42-18t-18-42v-440q0-24 18-42t42-18h680q24 0 42 18t18 42v440q0 24-18 42t-42 18H540v100h56q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H364q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h56ZM140-340h680v-440H140v440Zm0 0v-440 440Z"
		/>
	</svg>
);
